import { render } from "./page-entry.vue?vue&type=template&id=638cb347&scoped=true&lang=html"
import script from "./page-entry.vue?vue&type=script&lang=js"
export * from "./page-entry.vue?vue&type=script&lang=js"

import "./page-entry.vue?vue&type=style&index=0&id=638cb347&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638cb347"]])

export default __exports__